import Preview from "./Preview/Preview";


const DrawerNavigatorRouteProps=[
    {
        name:"id",
        type:"string",
        required:true,
        description:"Route id, required",
    },
    {
        name:"title",
        type:"string",
        description:"Route header title. If title is undefined, the id value is used",
    },
    {
        name:"memorize",
        type:"boolean",
        description:`
            If true, the route is rendered once, using the HTMLElement returned by the component property for next renders.
            @Useful when the route is static (returns the same UI everytime).
            @default true
        `,
    },
    {
        name:"component",
        type:"(props:{parent:HTMLElement})=>HTMLElement",
        props:[
            {
                name:"parent",
                type:"HTMLElement",
                description:"Route component container",
            },
        ],
    },
];


export default {
    id:"DrawerNavigator",
    parent:{name:"View"},
    description:"",
    preview:Preview,
    props:[
        {
            name:"headerClassName",
            type:"string",
            description:"Header container className",

        },
        {
            name:"containerClassName",
            type:"string",
            description:"Route component container className",
        },
        {
            name:"drawerClassName",
            type:"string",
        },
        {
            name:"routes",
            type:"DrawerNavigatorRoute[]",
            props:[
                {
                    name:"DrawerNavigatorRoute",
                    type:"object",
                    props:DrawerNavigatorRouteProps,
                }
            ],
        },
        {
            name:"initialId",
            type:"string",
            description:"First chosen route id, default to routes[0].id",
        },
        {
            name:"tintColor",
            type:"string",
            description:"hexadecimal format required, default #1e90ff",
        },
        {
            name:"renderHeader",
            type:"(props:object):HTMLElement",
            description:"for custom header generation",
            props:[{
                name:"props",type:"object",
                props:[
                    {
                        name:"parent",
                        type:"HTMLElement",
                        description:"header element container",
                    },
                    {
                        name:"route",
                        type:"DrawerNavigatorRoute",
                        description:"a shallow copy of the route definition object",
                        props:[{
                            name:"render",
                            type:"():HTMLElement",
                            description:"force rerendering the route",
                        }],
                    },
                    {
                        name:"defaultIcon",
                        type:"(color?:string)=>string",
                        description:"default header icon",
                    },
                ],
            }],
        },
        {
            name:"renderDrawerHeader",
            type:"(props:{parent:HTMLElement}):HTMLElement"
        },
        {
            name:"renderDrawerFooter",
            type:"(props:{parent:HTMLElement}):HTMLElement"
        },
    ],
    methods:[
        {
            name:"showDrawer",
            type:"():void",
            description:"Shows the drawer view",
        },
        {
            name:"navigate",
            type:"(routeId:string):void",
            description:"Shows a specific route",
        }
    ],
};
